import React from "react";
import { Button, Card, CardHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { Active_Merchant_PG } from "../../../redux/slices/payinPayoutSlice";
import { useEffect } from "react";
import { Table, TableRow } from "../../../components/Table";
import {
  TRA_FILTER,
  TRA_PAGINATION_OPTIONS,
  showToaster,
} from "../../../constant";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useAutoRefreshTime, useRole } from "../../../redux/slices/authSlice";
import { useLocation } from "react-router-dom";
import useAutoRefresh from "../../../components/useAutoRefresh";
import ActiveMerchantPGModal from "../../../components/Custom/Modals/ActiveMerchantPG/ActiveMerchantPGModal";
import ActiveMerchantPayout from "./ActiveMerchantPayout";

const ActiveMerchantPayinPG = () => {
  const [filterColumns, setFilterColumns] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [viewData, setViewData] = useState(false);
  const [filter, setFilter] = useState(TRA_FILTER);
  const role = useRole("Active Merchant Pg");
  const autoRefreshTime = useAutoRefreshTime();
  const location = useLocation()?.pathname?.split?.("/");
  const { updateRefreshTime } = useAutoRefresh(location?.at(-1));
  const dispatch = useDispatch()


  const { getActiveMerchantPGState } = useSelector(
    (state) => state.payinPayout
  );

  const columns = [
    {
      title: "Merchant Name",
      name: "merchantName",
    },
    {
      title: "Label",
      name: "pg_label",
      Cell: ({ pg_label }) => {
        if (!pg_label || typeof pg_label !== "object") return null;

        return (
          <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
            {Object?.entries?.(pg_label || {})?.map?.(([pgKey, labels], index) => (
              <div key={index}>
                <strong>{pgKey} : </strong> {Array.isArray?.(labels) ? labels?.join?.(", ") : labels}
              </div>
            ))}
          </div>
        );
      }
    },
    {
      title: "Action",
      name: "Action",
      Cell: (val) => {
        return (
          <Button
            className="submitTransbutton"
            onClick={() => {
              setViewData(val)
            }}
          >
            Details
          </Button>
        );
      }
    }
    /*  {
       title: "Action",
       name: "Action",
       Cell: (val) => {
         return (
           <CopyToClipboard text={` ${val?.merchantName} »»»» ${val?.pgLabel}`}>
             <Button
               className="submitTransbutton"
               onClick={() => {
                 showToaster("Copied");
               }}
             >
               Copy
             </Button>
           </CopyToClipboard>
         );
       },
     }, */
  ];

  const ongetActiveMerchantPG = async () => {
    try {
      setIsLoading(true);
      const payload = {
        ...filter,
      };
      await dispatch(Active_Merchant_PG(payload)).unwrap();
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const newColumns = columns?.map((item) => item?.name);
    setFilterColumns(newColumns);
  }, []);

  useEffect(() => {
    if (role.includes("activeMerchantPg-list")) {
      ongetActiveMerchantPG();
    }
  }, [filter]);

  useEffect(() => {
    const IntervalClick = setInterval(() => {
      if (refresh) {
        ongetActiveMerchantPG();
      }
    }, autoRefreshTime);
    return () => clearInterval(IntervalClick);
  }, [refresh, filter]);

  const prepareCopyContent = (data) => {
    let temp = [];
    if (data && data?.length > 0) {
      temp = data?.map?.((dt) => {
        if (!dt?.merchantName || !dt?.pg_label) return "";

        let content = `--- ${dt?.merchantName} ---`;
        Object.entries?.(dt?.pg_label || {})?.forEach?.(([pg, labels]) => {
          const labelStr = Array?.isArray?.(labels) ? labels?.join?.(", ") : labels;
          content += `\n  ${pg}: ${labelStr}`;
        });
        return content;
      });
    }

    return temp?.join?.("\n\n")?.trim();
  };

  if (!role.includes("activeMerchantPg-list")) {
    return;
  }

  return (
    <>
      {role.includes("activeMerchantPg-list") ? (
        <>
          <div
            className={`payoutmanual-main-div ${isLoading && refresh ? "opacity-25" : ""
              }`}
          >
            <Card>
              <CardHeader>
                <div className="d-flex align-items-center w-100 justify-content-end">
                  <div className="d-flex gap-1">
                    <CopyToClipboard
                      text={prepareCopyContent(Object.values?.(getActiveMerchantPGState?.data || {}))}
                    >
                      <Button
                        className={"filterbtn"}
                        disabled={
                          !Object.keys?.(getActiveMerchantPGState?.data || {})?.length|| isLoading
                        }
                        onClick={(e) => {
                          showToaster("Copied");
                        }}
                      >
                        Copy
                      </Button>
                    </CopyToClipboard>
                    <Button
                      type="button"
                      className={`${refresh ? "" : "filterbtn"} gap`}
                      color={refresh ? "primary" : ""}
                      onClick={() => {
                        setRefresh(!refresh)
                        if (!refresh) {
                          updateRefreshTime();
                        }
                      }}
                      title="Auto refresh"
                    >
                      {refresh ? (
                        <i className="fa-solid fa-arrows-rotate  rotate-animation"></i>
                      ) : (
                        <i className="fa-solid fa-arrows-rotate"></i>
                      )}
                      Auto Refresh
                    </Button>
                  </div>
                </div>
              </CardHeader>
              <Table
                columns={columns}
                filterColumns={filterColumns}
                isLoading={isLoading && !refresh}
                data={!!Object.values?.(getActiveMerchantPGState?.data || {}) || []}
                isData={!!Object.keys?.(getActiveMerchantPGState?.data || {})?.length}
                count={getActiveMerchantPGState?.total_item || 0}
                pagination={filter}
                isExpandable={false}
                handlePaginationChange={(pagination) => {
                  setFilter({
                    ...filter,
                    ...pagination,
                  });
                }}
                onColumnsChange={(columns) => {
                  setFilterColumns(columns);
                }}
                paginationOptions={TRA_PAGINATION_OPTIONS}
              >
                {Object.values?.(getActiveMerchantPGState?.data || {})?.map?.((item) => {
                  return (
                    <TableRow
                      columns={columns}
                      filterColumns={filterColumns}
                      item={item}
                      isExpandable={false}
                    />
                  );
                })}
              </Table>
            </Card>
          </div>
        </>
      ) : null}
      <ActiveMerchantPGModal
        data={viewData}
        isViewsendDataModal={viewData}
        onCloseModal={() => {
          setViewData(false)
        }}
      />
    </>
  );
};

const ActiveMerchantPG = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const role = useRole("Active Merchant Pg");

  const tabsData = [
    ...(role.includes("activeMerchantPg-list") ? [{ title: "Payin", component: ActiveMerchantPayinPG }] : []),
    ...(role.includes("activeMerchantPayoutPg-list") ? [{ title: "Payout", component: ActiveMerchantPayout }] : []),
  ];

  const Component = tabsData?.[currentTab]?.component;

  if (!role.includes("activeMerchantPg-list")) {
    return;
  }

  return (
    <Card>
      <CardHeader className="flex-column  align-items-start">
        <div className="d-flex align-items-center w-100 justify-content-between">
          <div>
            <h4 className="main-title">
              <b>Active Merchant PG</b>
            </h4>
          </div>
          <div
            className="d-flex my-xl-auto right-content align-items-end button-space"
            style={{ flexWrap: "wrap" }}
          >
            {tabsData?.map((tab, index) => {
              return (
                <Button
                  className={
                    currentTab === index ? "btn-primary" : "filterbtn"
                  }
                  color={currentTab === index ? "btn-primary" : ""}
                  onClick={() => {
                    setCurrentTab(index);

                  }}
                >
                  {tab.title}
                </Button>
              );
            })}
          </div>
        </div>
      </CardHeader>
      <Component />
    </Card>
  );
};

export default ActiveMerchantPG;
